<template>
  <v-container fluid class="mx-0 px-0">
    <template v-if="loading && isMinimal">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-skeleton-loader type="paragraph" v-if="loading" />
    </template>
    <template v-if="!loading || !isMinimal">
      <!-- <paieska-parametrai
        v-if="showPaieskaParametrai"
        :parametrai="paieska.pai_parametrai"
        :loading="loading"
      /> -->
      <template v-if="isSarasas">
        <v-card class="mb-4 py-2">
          <v-card-title class="mt-0 pt-1 pb-2">
            <h4>Paieškos rezultatas</h4>
          </v-card-title>
          <v-card-text class="mb-0 pb-2">
            <template v-if="isExpired">
              {{ expired }}
            </template>
            <template v-if="!isExpired">
              <template v-if="!isResult">
                {{ noResult }}
              </template>
              <template v-if="!isMinimal">
                <div class="mt-2">
                  <el-byla
                    v-for="byla in paieskaByla"
                    :key="byla.byl_id"
                    :byla="byla"
                    color="primary"
                    with-name
                  />
                </div>
              </template>
              <template v-if="isResult">
                <v-data-table
                  :class="tableClass"
                  :headers="filteredHeaders"
                  :items="itemsList"
                  :loading="loading"
                  :search="search"
                  :footer-props="{
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageText: 'Rodyti po:',
                    itemsPerPageAllText: 'visi',
                    itemsPerPageOptions: itemsPerPageOptions,
                  }"
                  :hide-default-footer="hideFooter"
                  :items-per-page="pageSize"
                  :expanded.sync="itemsList"
                >
                  <template #top v-if="!isMinimal">
                    <v-toolbar flat>
                      <v-text-field
                        v-model="search"
                        prepend-icon="mdi-magnify"
                        label=""
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <template v-if="item.uzsakoma">
                      <v-progress-circular
                        size="24"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </template>
                    <template v-if="!item.uzsakoma">
                      <el-button-icon
                        v-for="uzsakyti in item.uzsakyti"
                        :key="uzsakyti.israso_tipas"
                        primary
                        small
                        :loading="loadingUzsakyti"
                        :icon="uzsakyti.icon"
                        @click.native="confirmUzsakytiIsrasas(item, uzsakyti)"
                      >
                        {{ uzsakyti.text }}
                      </el-button-icon>
                    </template>

                    <el-button
                      v-if="item.canXml"
                      :key="item.xmlID"
                      x-small
                      @click.native="
                        paieskaObjXml(item.obj_identifikavimo_kodas)
                      "
                      >XML</el-button
                    >
                    <el-button
                      v-if="item.canXmlIstorija"
                      :key="item.xmlIDIstorija"
                      x-small
                      @click.native="
                        paieskaObjXmlIstorija(item.obj_identifikavimo_kodas)
                      "
                      >XML istorija</el-button
                    >
                  </template>
                  <template
                    v-slot:expanded-item="{ headers, item }"
                    v-if="!isKodas"
                  >
                    <td></td>
                    <td :colspan="headers.length - 2">
                      <paieska-result-asmenys
                        :asmenys="item.asmenys"
                        :pai-tipas="paiTipas"
                      />
                    </td>
                    <td></td>
                  </template>
                  <template slot="loading">
                    Kraunasi...
                  </template>
                  <template slot="no-results">
                    Duomenų nėra
                  </template>
                  <template slot="no-data">
                    Duomenų nėra
                  </template>
                  <template #[`footer.page-text`]="props">
                    Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
                    {{ props.itemsLength }}
                  </template>
                </v-data-table>
              </template>
            </template>
          </v-card-text>
        </v-card>
      </template>
      <template v-if="isPranesimas">
        <v-card class="mb-4 py-2">
          <v-card-title class="mt-0 pt-1 pb-2">
            <h4>Registro(-ų) atsakymas</h4>
          </v-card-title>
          <v-card-text class="mb-0 pb-2">
            <v-alert dense outlined type="error">
              {{ pranesimas }}
            </v-alert>
          </v-card-text>
        </v-card>
      </template>
      <template v-if="isPatikra">
        <v-card class="mb-4 py-2">
          <v-card-title class="mt-0 pt-1 pb-2">
            <h4>Registro(-ų) atsakymas</h4>
          </v-card-title>
          <v-card-text class="mb-0 pb-2">
            <template v-if="isExpired">
              {{ expired }}
            </template>
            <template v-if="!isExpired">
              {{ atsakymas }}
              <template v-if="!isMinimal">
                <div class="mt-2">
                  <el-byla
                    v-for="byla in paieskaByla"
                    :key="byla.byl_id"
                    :byla="byla"
                    color="primary"
                    with-name
                  />
                </div>
              </template>
            </template>
          </v-card-text>
        </v-card>
      </template>
      <template v-if="showVykdoma">
        <v-card class="mb-4 py-2">
          <v-card-title class="mt-0 pt-1 pb-2">
            <h4>Vykdoma paieška</h4>
          </v-card-title>
          <v-card-text class="mb-0 pb-2">
            <v-skeleton-loader type="paragraph" />
          </v-card-text>
        </v-card>
      </template>
      <template v-if="isNeivykdyta">
        <v-card class="mb-4 py-2">
          <v-card-title class="mt-0 pt-1 pb-2">
            <h4>Registro(-ų) atsakymas</h4>
          </v-card-title>
          <v-card-text class="mb-0 pb-2">
            Duomenų nerasta
          </v-card-text>
        </v-card>
      </template>
    </template>

    <modal-confirm
      :title="confirmTitle"
      :text="confirmText"
      action="Uzsakyti"
      v-model="showConfirm"
      :item="confirmItem"
      @confirmUzsakyti="uzsakytiIsrasas"
      @cancelConfirm="cancelUzsakytiIsrasas"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../mixins/math'
import userRole from '../../mixins/userRole'
import PaieskaResultAsmenys from './PaieskaResultAsmenys'
// import PaieskaParametrai from './PaieskaParametrai'
import ModalConfirm from '../modals/ModalConfirm'

export default {
  name: 'PaieskaResult',
  props: {
    paieskaId: Number,
    minimal: { type: Boolean, default: false },
  },
  components: { PaieskaResultAsmenys, ModalConfirm },
  mixins: [math, userRole],
  data() {
    return {
      loading: false,
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      paieska: {
        pai_parametrai: [],
        expired: false,
        atsakymas: null,
        rezultatai: [
          {
            uzsakoma: false,
          },
        ],
        bylos: [],
      },
      saugojimoLaikas: null,
      showConfirm: false,
      confirmTitle: null,
      confirmText: null,
      confirmItem: null,
      confirmUzsakyti: null,
      loadingUzsakyti: false,

      lockInterval: null,
      lockTimeoutFull: 1000,
      lockTimeoutMinimal: 10000,
    }
  },
  computed: {
    ...mapGetters(['paieskaKaina', 'appSavitarna']),

    headers() {
      return [
        {
          text: 'Eil. Nr.',
          align: 'start',
          value: 'eil_nr',
        },
        {
          text: 'Objektas',
          align: 'start',
          value: 'objektas',
        },
        {
          text: 'Duomenų teikėjo dokumento numeris',
          align: 'start',
          value: 'obj_pradinis_dokumento_numeris',
        },
        {
          text: 'Duomenų teikėjo dokumento data',
          align: 'start',
          value: 'obj_pradinis_dokumento_data_laikas',
        },
        {
          text: 'Įregistravimo registre data ir laikas',
          align: 'start',
          value: 'obj_iregistravimo_data',
        },
        {
          text: 'Išregistravimo iš registro data ir laikas',
          align: 'start',
          value: 'obj_isregistravimo_data',
          hide: !this.roleOr(['P_IA_pagal_ID', 'P_IAT_pagal_ID']),
        },
        {
          text: 'Išrašų užsakymas',
          align: 'start',
          value: 'actions',
          hide: !this.galiUzsakytiIsrasa,
        },
        {
          text: 'Kaina, Eur',
          align: 'start',
          value: 'kaina',
          hide: !this.galiUzsakytiIsrasa || !this.showKaina || true,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.paieska.rezultatai.map((item, index) => {
        item.eil_nr = index + 1
        item.objektas = `${item.obj_tipas_pavadinimas} ${item.obj_identifikavimo_kodas}`
        item.archyvas_tekstas = item.archyvas ? 'Taip' : 'Ne'

        item.isSutartis = item.obj_tipas.includes('sutartis')
        item.kaina =
          this.paieska.pai_parametrai.apie_save &&
          this.role('EL_FA') &&
          !this.role('EL_JA')
            ? this.moneyformat(0)
            : this.moneyformat(
                item.isSutartis
                  ? this.paieskaKaina.israsas_sutartis.kaina
                  : this.paieskaKaina.israsas_hipoteka.kaina
              )
        item.uzsakoma = false

        item.uzsakyti = []
        if (
          (this.role('P_I_pagal_ID') && !item.archyvas) ||
          (this.role('P_IA_pagal_ID') && item.archyvas) ||
          this.roleOr(['EL_FA', 'EL_JA'])
        ) {
          item.uzsakyti.push({
            pai_id: this.paieska.pai_id,
            dok_id: item.dok_id,
            text: item.archyvas
              ? 'Užsakyti archyvinį išrašą'
              : 'Užsakyti išrašą',
            israso_tipas: item.archyvas
              ? 'paieska_archyvas'
              : 'paieska_issamus',
            confirm_text: item.archyvas
              ? `Ar norite užsakyti archyvinį išrašą <b>${
                  item.objektas
                }</b>?  ${this.getIsrasasKainaText(item.obj_tipas)}`
              : `Ar norite užsakyti išrašą <b>${
                  item.objektas
                }</b>? ${this.getIsrasasKainaText(item.obj_tipas)}`,
            icon: 'mdi-text-box-check-outline',
          })
        }
        if (
          !this.isSavitarna &&
          !item.isSutartis &&
          ((this.role('P_IT_pagal_ID') && !item.archyvas) ||
            (this.role('P_IAT_pagal_ID') && item.archyvas))
        ) {
          const kaina = 0
          item.uzsakyti.push({
            pai_id: this.paieska.pai_id,
            dok_id: item.dok_id,
            text: item.archyvas
              ? 'Užsakyti archyvinį išrašą su turiniu'
              : 'Užsakyti išrašą su turiniu',
            israso_tipas: item.archyvas
              ? 'paieska_turinys_archyvas'
              : 'paieska_turinys_issamus',
            confirm_text: item.archyvas
              ? `Ar norite užsakyti archyvinį išrašą <b>${
                  item.objektas
                }</b> su turiniu?  ${this.getIsrasasKainaText(
                  item.obj_tipas,
                  'turinys'
                )}`
              : `Ar norite užsakyti išrašą <b>${
                  item.objektas
                }</b> su turiniu?  ${this.getIsrasasKainaText(
                  item.obj_tipas,
                  'turinys'
                )}`,
            canDokZyma: this.roleRG,
            dokZyma: true,
            icon: 'mdi-text-box-plus-outline',
          })
        }
        if (
          !this.isSavitarna &&
          ((this.role('P_matyti_istorija') && !item.archyvas) ||
            this.roleOr(['EL_FA', 'EL_JA']))
        ) {
          item.uzsakyti.push({
            pai_id: this.paieska.pai_id,
            dok_id: item.dok_id,
            text: 'Užsakyti išrašą su istorija',
            israso_tipas: 'paieska_istorija',
            confirm_text: `Ar norite užsakyti išrašą <b>${
              item.objektas
            }</b> su istorija?  ${this.getIsrasasKainaText(
              item.obj_tipas,
              'istorija'
            )}<br />* Istoriniai duomenys išraše atvaizduojami nuo 2022 m. sausio 1 d.`,
            icon: 'mdi-text-box-plus-outline',
          })
        }

        item.xmlID = `xml-${this.paieska.pai_id}-${item.eil_nr}`
        item.canXml = !item.uzsakoma && this.isLocal
        item.xmlIDIstorija = `xml-istorija-${this.paieska.pai_id}-${item.eil_nr}`
        item.canXmlIstorija = !item.uzsakoma && this.isLocal

        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    paieskaByla() {
      if (this.paiTipas === 'kodas') {
        return []
      }
      return this.paieska.bylos.map(byla => {
        let iconTitle = 'Išrašas'
        if (byla.byl_tipas === 'santrauka') {
          iconTitle = 'Sąrašas'
        }
        if (byla.byl_tipas === 'patikra') {
          iconTitle = 'Patikra'
        }
        return {
          ...byla,
          byl_url: `byla/${byla.byl_id}/${byla.byl_hash}/content`,
          byl_pavadinimas: this.paieska.pai_tipas_pavadinimas,
          obj_tipas: this.paieska.obj_tipas,
          icon_title: iconTitle,
        }
      })
    },
    tableClass() {
      return this.isMinimal ? 'paieska-result miniTable' : 'paieska-result mt-2'
    },
    isMinimal() {
      return this.minimal
    },
    showPaieskaParametrai() {
      return this.isMinimal
    },
    isVykdoma() {
      return this.paieska.pai_busena === 'vykdoma'
    },
    showVykdoma() {
      return this.isVykdoma || (this.loading && !this.isMinimal)
    },
    isIvykdyta() {
      return this.paieska.pai_busena === 'ivykdyta'
    },
    isNeivykdyta() {
      return this.paieska.pai_busena === 'neivykdyta'
    },
    paslauga() {
      return this.paieska.pai_parametrai.paslauga ?? null
    },
    isSarasas() {
      return (
        (this.paslauga === 'sarasas' ||
          (this.paslauga === null && this.isKodas)) &&
        this.isIvykdyta &&
        !this.isPranesimas
      )
    },
    isResult() {
      return this.paieska.rezultatai && this.paieska.rezultatai.length > 0
    },
    noResult() {
      return 'Registre nėra duomenų pagal nurodytus paieškos kriterijus.'
    },
    isPatikra() {
      return this.paslauga === 'patikra' && this.isIvykdyta
    },
    isPranesimas() {
      return this.pranesimas !== null && this.isIvykdyta
    },
    paiTipas() {
      return this.paieska.pai_tipas
    },
    isJuridinis() {
      return this.paiTipas === 'juridinis'
    },
    isFizinis() {
      return this.paiTipas === 'fizinis'
    },
    isTurtas() {
      return this.paiTipas === 'turtas'
    },
    isKodas() {
      return this.paiTipas === 'kodas'
    },
    atsakymas() {
      if (this.paieska.atsakymas) {
        if (this.isTurtas || this.isKodas) {
          return 'Turtas įkeistas.'
        } else {
          return 'Asmuo įrašytas hipotekoje (įkeitime) skolininku arba savininku (įkaito davėju).'
        }
      } else {
        if (this.isTurtas || this.isKodas) {
          return 'Turtas neįkeistas.'
        } else {
          return 'Asmuo neįrašytas hipotekoje (įkeitime) skolininku arba savininku (įkaito davėju).'
        }
      }
    },
    pranesimas() {
      return this.paieska.pranesimas
    },
    expired() {
      return `Paieškos rezultatas pašalintas praėjus ${this.saugojimoLaikas} k.d. nuo paieškos atlikimo.`
    },
    isExpired() {
      return this.paieska.expired
    },
    galiUzsakytiIsrasa() {
      return this.roleOr([
        'P_I_pagal_ID',
        'P_IT_pagal_ID',
        'P_IA_pagal_ID',
        'P_IAT_pagal_ID',
        'EL_FA',
        'EL_JA',
      ])
    },
    showKaina() {
      return !(
        this.roleRG ||
        this.role('KAC_darbuotojas') ||
        this.roleSkaitytojas
      )
    },
    lockTimeout() {
      return this.isMinimal ? this.lockTimeoutMinimal : this.lockTimeoutFull
    },
    isLocal() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop' ||
        process.env.VUE_APP_LOCAL === 'preprod'
      )
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
    isSavitarna() {
      return this.appSavitarna
    },
  },
  beforeDestroy() {
    this.stopLoading()
  },
  created() {
    this.loading = true
    this.getData()
  },
  methods: {
    getData() {
      if (this.paieskaId > 0) {
        this.$axios
          .get(`paieska/${this.paieskaId}`)
          .then(res => {
            this.paieska = res.data.paieska
            this.saugojimoLaikas = res.data.saugojimo_laikas
            this.checkLoading()
          })
          .catch(err => {
            window._VMA.$emit('DATA_ERROR', err.response.data.message)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    checkLoading() {
      if (this.isVykdoma) {
        if (!this.lockInterval) {
          this.lockInterval = setInterval(() => {
            this.getData()
          }, this.lockTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.lockInterval)
    },
    confirmUzsakytiIsrasas(item, uzsakyti) {
      this.loadingUzsakyti = true
      this.confirmTitle = 'Išrašo užsakymas'
      this.confirmText = uzsakyti.confirm_text
      this.confirmAction = 'Uzsakyti'
      this.confirmItem = uzsakyti
      this.confirmUzsakyti = uzsakyti
      this.showConfirm = true
    },
    cancelUzsakytiIsrasas() {
      this.confirmItem = null
      this.loadingUzsakyti = false
    },
    uzsakytiIsrasas(uzsakyti) {
      this.confirmItem = uzsakyti
      this.confirmItem.uzsakoma = true

      const data = {
        pai_id: this.confirmUzsakyti.pai_id,
        dok_id: this.confirmUzsakyti.dok_id,
        israso_tipas: this.confirmUzsakyti.israso_tipas,
        dok_zyma: this.confirmUzsakyti.dokZyma ?? true,
      }
      this.$axios
        .post(`paieska/israsas`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          if (this.isMinimal) {
            this.$emit('updateList')
          } else {
            if (this.isSavitarna) {
              this.$router.push({ name: 'savPaieskaMano' })
            } else {
              this.$router.push({ name: 'paieskaMano' })
            }
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.resetUzsakoma()
          this.confirmItem = null
          this.confirmUzsakyti = null
          this.loadingUzsakyti = false
        })
    },
    resetUzsakoma() {
      this.paieska.rezultatai = this.paieska.rezultatai.map(item => {
        item.uzsakoma = false
        return item
      })
    },
    paieskaObjXml(objektasID) {
      this.$axios
        .get(`xml/${objektasID}/0`)
        .then(res => {
          let fileData = res.data
          var fileURL = window.URL.createObjectURL(new Blob([fileData]))
          var fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            this.safeFileName('paieska_obj.xml')
          )
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    paieskaObjXmlIstorija(objektasID) {
      this.$axios
        .get(`xml/${objektasID}/1`)
        .then(res => {
          let fileData = res.data
          var fileURL = window.URL.createObjectURL(new Blob([fileData]))
          var fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            this.safeFileName('paieska_obj_istorija.xml')
          )
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    getIsrasasKaina(israsasTipas) {
      if (
        this.paieska.pai_parametrai.apie_save &&
        this.role('EL_FA') &&
        !this.role('EL_JA')
      ) {
        return this.moneyformat(0)
      }
      if (!this.paieskaKaina[israsasTipas]) {
        return this.moneyformat(0)
      }
      return this.moneyformat(this.paieskaKaina[israsasTipas].kaina)
    },
    getIsrasasTipas(objektasTipas, israsasKey) {
      const isSutartis = objektasTipas.includes('sutartis')

      if (israsasKey === 'istorija') {
        return isSutartis
          ? 'israsas_istorija_sutartis'
          : 'israsas_istorija_hipoteka'
      }

      return isSutartis ? 'israsas_sutartis' : 'israsas_hipoteka'
    },
    getIsrasasKainaText(objektasTipas, israsasKey) {
      if (!this.showKaina || !objektasTipas) {
        return ''
      }
      const israsasTipas = this.getIsrasasTipas(objektasTipas, israsasKey)

      return `<div class="parametrai"><dl>
                    <dt>Išrašo kaina</dt>
                    <dd>${this.getIsrasasKaina(israsasTipas)} Eur</dd>
                </dl></div>`
    },
  },
}
</script>
<style lang="scss">
.paieska-result
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: inset 0px -4px 8px -5px rgba(50, 50, 50, 0.75);
}
.parametrai {
  dl {
    display: flex;
    flex-flow: row wrap;
  }
  dt {
    flex-basis: 40%;
    padding: 2px 4px;
    text-align: right;
    font-weight: 400;
  }
  dd {
    flex-basis: 40%;
    flex-grow: 1;
    margin: 0;
    padding: 2px 4px;
    font-weight: 600;
  }
}
</style>
